import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (available) => ({
  minWidth: 4.5,
  cursor: available ? 'pointer' : 'default',
});

export const icon: SxStyleFunc<boolean> = (available) => ({
  '&:hover': {
    color: available
      ? (p) => p.palette.primary[300]
      : (p) => p.palette.grey[400],
  },
});
